import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import ClosebookMiddleware from "../../../../middleware/modules/accounting/closebook";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import Closebook from "../../../../components/modules/accounting/closebook";
// middlewares

const mapStateToProps = ({ auth, closebook }) => ({
  isProcessing: closebook.isProcessing,
  isProcessingData: closebook?.isProcessingData||false,
  isError: closebook.isError,
  errorMessage: closebook.errorMessage,
  processText:closebook.processText,
  cutoff:closebook.cutoff,
  data:closebook.data
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      reset: () => ClosebookMiddleware.reset(),
      process: (params) => ClosebookMiddleware.process(params),
      open: (params) => ClosebookMiddleware.open(params),
      search: (params) => ClosebookMiddleware.search(params),
    },
    dispatch
  );
};
class ClosebookContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.reset();
     const search = {
      limit: 10,
    };
    this.props.search(search);
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>{i18n.t("Closebook")}</title>
        </Helmet>

        <Closebook
            {...this.props}
        />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClosebookContainer);
